/**
 * Attempts to determine the embedding/parent origin.
 * - If in an iframe, use document.referrer's origin (path-safe).
 * - Fallback to window.location.origin.
 * - Always returns a string (best effort) or null if nothing is available.
 */
export function getParentOrigin(): string | null {
    try {
        const isFramed = window.self !== window.top //add .top if in iframe;
        if (isFramed && document.referrer) {
            const refUrl = new URL(document.referrer);
            // Return the full referrer URL (not just origin) so our "contains" matching can work,
            // but also log both in App.tsx for clarity.
            return refUrl.href;
        }
    } catch (err) {
        // cross-origin access can throw; ignore and continue
    }

    try {
        return window.location.href || window.location.origin || null;
    } catch {
        return null;
    }
}
